import { render, staticRenderFns } from "./mixProductModal.vue?vue&type=template&id=99dcdde6&"
import script from "./mixProductModal.vue?vue&type=script&lang=js&"
export * from "./mixProductModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports